export default __webpack_public_path__ + "src/images/packages/eco-karoo-lodge/55fbbf912dbe8a29e4d3c4bebb6816ff-1.png";